"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBulkAssertions = void 0;
const react_1 = require("react");
const graphql_1 = require("../../../../__generated__/graphql");
const create_proposal_hook_1 = require("./create-proposal.hook");
const delete_proposal_hook_1 = require("./delete-proposal.hook");
const edit_proposal_hook_1 = require("./edit-proposal.hook");
const proposal_status_hook_1 = require("./proposal-status.hook");
const useBulkAssertions = ({ catalogId, onCompleted, }) => {
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const [error, setError] = (0, react_1.useState)(null);
    const { createProposal } = (0, create_proposal_hook_1.useCreateProposal)({
        catalog: catalogId,
        action: graphql_1.ProposalAction.Augment,
        description: '',
    });
    const { proposalStatus } = (0, proposal_status_hook_1.useProposalStatus)();
    const { editProposal } = (0, edit_proposal_hook_1.useEditProposal)();
    const { deleteProposal } = (0, delete_proposal_hook_1.useDeleteProposal)();
    const handleError = (0, react_1.useCallback)((error) => {
        setIsLoading(false);
        setError(error);
    }, []);
    const handleEditProposalError = (0, react_1.useCallback)((error, proposalId) => {
        void deleteProposal({
            variables: {
                proposal: { id: proposalId, clientMutationId: '' },
            },
            onCompleted: () => handleError(error),
            onError: handleError,
        });
    }, [deleteProposal, handleError]);
    const addBulkAssertions = (0, react_1.useCallback)((assertions, proposalAction) => {
        setIsLoading(true);
        setError(null);
        void createProposal({
            variables: {
                catalog: catalogId,
                action: proposalAction !== null && proposalAction !== void 0 ? proposalAction : graphql_1.ProposalAction.Augment,
                description: '',
            },
            onError: handleError,
            onCompleted: (data) => {
                const { id } = data.proposal;
                void editProposal({
                    variables: {
                        proposal: {
                            id,
                            addAssertions: assertions,
                            clientMutationId: '',
                        },
                    },
                    onError: (error) => handleEditProposalError(error, id),
                    onCompleted: () => {
                        void proposalStatus({
                            fetchPolicy: 'no-cache',
                            variables: {
                                proposal: {
                                    id,
                                    status: graphql_1.ProposalStatus.Committed,
                                    clientMutationId: '',
                                },
                            },
                            onError: handleError,
                            onCompleted: () => {
                                var _a, _b, _c, _d;
                                setIsLoading(false);
                                onCompleted === null || onCompleted === void 0 ? void 0 : onCompleted({
                                    selectedNodeTitle: (_a = assertions[0].categories) === null || _a === void 0 ? void 0 : _a[0].category,
                                    productsCount: (_d = (_c = (_b = assertions[0].filter) === null || _b === void 0 ? void 0 : _b.id) === null || _c === void 0 ? void 0 : _c.in) === null || _d === void 0 ? void 0 : _d.length,
                                });
                            },
                        });
                    },
                });
            },
        });
    }, [catalogId, createProposal, editProposal, handleEditProposalError, handleError, onCompleted, proposalStatus]);
    return {
        isLoading,
        error,
        addBulkAssertions,
    };
};
exports.useBulkAssertions = useBulkAssertions;
